// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gc-0";
export var fulfillmentPanelBody = "_gc-1";